import React from 'react';
import GetIcon from '../utils/Icon';

const ActionButtonDropdown = ({ id, onView, onEdit, onDelete, status = null, actions = ['view', 'edit', 'delete'] }) => {
  return (
    <p className="d-flex justify-content-center m-0" style={{ gap: '5px' }}>
      {actions.includes('view') && (
        <span onClick={() => onView?.(id, status)} style={{ cursor: 'pointer' }} title="View">
          <GetIcon iconName="MdOutlineRemoveRedEye" design="actionbtn" />
        </span>
      )}
      {actions.includes('edit') && (
        <span onClick={() => onEdit?.(id, status)} style={{ cursor: 'pointer' }} title="Edit">
          <GetIcon iconName="BiEditAlt" design="actionbtn" />
        </span>
      )}
      {actions.includes('delete') && (
        <span onClick={() => onDelete?.(id)} style={{ cursor: 'pointer' }} title="Delete">
          <GetIcon iconName="MdOutlineDelete" design="actionbtn" />
        </span>
      )}
    </p>
  );
};

export default ActionButtonDropdown;
